/**
 * Status-aware refetching, owned once for all three clients (block 08).
 *
 * A URL capture returns in under 500ms with `status: 'processing'` and settles
 * to `ready` a few seconds later in a worker. Without this the card would sit
 * there until the user reloaded, which is the failure the block's third smoke
 * step exists to catch. It lives here rather than in a component so that the
 * webapp, the extension popup and mobile inherit it — no client writes its own
 * polling loop (plan §9.1).
 */
/** Fast enough to feel automatic, slow enough not to be a load test. */
const INTERVAL_MS = 3000;
/**
 * The ceiling, in polls — about two minutes at the interval above.
 *
 * Counted from `dataUpdateCount` at the moment a burst *starts* rather than
 * over the query's lifetime: a tab left open all morning accumulates updates
 * from window focus and from the invalidation every capture fires, so a
 * lifetime count would quietly stop reacting to processing nooks until reload.
 * The baseline is dropped as soon as nothing is processing, so the next capture
 * gets a full budget.
 */
const MAX_POLLS = 40;
const baselines = new Map();
export function processingRefetch(queryHash, dataUpdateCount, processing) {
    if (!processing) {
        baselines.delete(queryHash);
        return false;
    }
    const baseline = baselines.get(queryHash) ?? dataUpdateCount;
    baselines.set(queryHash, baseline);
    return dataUpdateCount - baseline < MAX_POLLS ? INTERVAL_MS : false;
}
//# sourceMappingURL=processing.js.map